import { Box } from '@mui/system';
import { Body1 } from './elements/Typography';

// TODO: add input field to set lead Id
export const NoLead = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
    <Body1 locale="lead.noLead" />
  </Box>
);
